module.exports = __webpack_public_path__ + "img/gobck.65f78ea3.svg";